export default (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  dialogPaper: {
    minHeight: "150px"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  panelHeader: {
    marginTop: 15,
    fontSize: "1rem",
    fontWeight: 600,
    marginBottom: "1rem",
  },
  checkBoxStyle: {
    marginLeft: "15px",
    marginRight: 0,
  },
  inputLabel: {
    color: "rgba(0, 0, 0)",
    paddingBottom: 10,
    fontWeight: 600,
  },
  switchBase: {
    color: "#52d869",
    "&$checked": {
      color: "#52d869",
    },
    "&$checked + $track": {
      backgroundColor: "#52d869",
    },
  },
  checked: {},
  track: {},
});
